module.exports = __webpack_public_path__ + "img/Spaces.38288813.png";